// First words with you (alphabet) — personalise page: name + Boy/Girl + skin tone.
// Both genders have a light and a dark character. Saves the profile, then → preview.
document.addEventListener("DOMContentLoaded", async function () {
  const profile = await loadProfile();
  let selectedGender = profile?.gender || "BOY";
  let selectedTone = profile?.skinTone || "light";

  const childNameInput = document.getElementById("childName");
  const nameError = document.getElementById("name-error");
  const buttons = document.querySelectorAll(".select-option");
  const continueBtn = document.getElementById("continue-btn");
  const charWrap = document.getElementById("character-options");
  const CHARS = window.ALPHABET_CHARS || {};

  function validateName(name) {
    if (name.includes(" ")) {
      return "Please enter only a first name without spaces.";
    }
    if (name.length > 11) {
      return "Your first name must not exceed 11 characters.";
    }
    if (!/^[A-Z][a-z]+$/.test(name)) {
      if (!/^[A-Za-z]+$/.test(name)) {
        return "Name must contain only alphabets.";
      }
      return "First letter should be uppercase, the rest lowercase (e.g., Noah).";
    }
    return null;
  }

  function checkForm() {
    const name = childNameInput.value.trim();
    const errorMsg = validateName(name);

    if (errorMsg) {
      nameError.textContent = errorMsg;
      nameError.style.display = "block";
      continueBtn.disabled = true;
    } else {
      nameError.style.display = "none";
      continueBtn.disabled = !selectedGender;
    }
  }

  function renderCharacters() {
    if (!charWrap) return;
    const list = CHARS[selectedGender] || [];
    // keep the chosen tone if this gender has it, otherwise fall back to the first
    if (!list.some((c) => c.tone === selectedTone)) {
      selectedTone = (list[0] && list[0].tone) || "light";
    }
    charWrap.innerHTML = "";
    list.forEach((c) => {
      const card = document.createElement("button");
      card.type = "button";
      card.className = "character-card" + (c.tone === selectedTone ? " active" : "");
      card.setAttribute("aria-label", c.label);
      const img = new Image();
      img.src = c.img;
      img.alt = c.label;
      card.appendChild(img);
      card.addEventListener("click", function () {
        selectedTone = c.tone;
        renderCharacters();
        checkForm();
      });
      charWrap.appendChild(card);
    });
  }

  function markActiveGender() {
    buttons.forEach((btn) => {
      btn.classList.toggle("active", btn.getAttribute("data-gender") === selectedGender);
    });
  }

  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      selectedGender = this.getAttribute("data-gender");
      markActiveGender();
      renderCharacters();
      checkForm();
    });
  });

  childNameInput.addEventListener("input", checkForm);
  childNameInput.addEventListener("change", checkForm);
  childNameInput.value = profile?.name || "";
  markActiveGender();
  renderCharacters();
  checkForm();

  continueBtn.addEventListener("click", async function () {
    const name = childNameInput.value.trim();
    const errorMsg = validateName(name);

    if (!errorMsg && selectedGender) {
      await saveProfile({
        name: name,
        gender: selectedGender,
        skinTone: selectedTone,
        dedicationText:
          "This little alphabet book is a gift for you " + name + ".\n" +
          "May Allah fill your heart with kindness,\n" +
          "help you learn something new every day,\n" +
          "and bless you with happiness wherever you go.",
        imageBase64: ""
      });
      window.location.href = "/pages/preview-alphabet";
    }
  });
});
